export default "https://cdn.questicon.mathletics.com/assets/audio/correct3Star-c7186a751cae36aaf5b86fd8832768a1.mp3";